import { render } from "./HistoryScreen.vue?vue&type=template&id=e891558a&scoped=true"
import script from "./HistoryScreen.vue?vue&type=script&lang=js"
export * from "./HistoryScreen.vue?vue&type=script&lang=js"

import "./HistoryScreen.vue?vue&type=style&index=0&id=e891558a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e891558a"]])

export default __exports__